// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"3828baae","228":"37160b69","293":"5c9e129d","316":"84d46ef3","413":"e598f070","478":"2c2497e0","503":"dc1c6cd2","678":"2a63d794","716":"e603ff50","958":"dcd9df3f","977":"238795c8"}[chunkId] + ".chunk.js";
};